import * as React from "react";
import BaseIcon from "../../BaseIcon";

export default class TopicOverviewIcon extends BaseIcon {
  getChildren = () => [
    <rect fill={this.getColor()} x="13" y="2" width="9" height="7" />,
    <rect fill={this.getColor()} x="13" y="11" width="9" height="11" />,
    <rect fill={this.getColor()} x="2" y="15" width="9" height="7" />,
    <rect fill={this.getColor()} x="2" y="2" width="9" height="11" />
  ];
  getViewBox = () => "0 0 24 24";
}
